// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 293 ? "component---src-pages-index-js" : chunkId) + "-" + {"108":"00e711a015153cc468a2","293":"bea21c498ec3a1f18f4e","452":"e0239ebc16ecec20e6f8"}[chunkId] + ".js";
};